import { IS_PRODUCTION } from 'constants/isDevelopment'
import { MEN_POWER_SUPPORT_DESCRIPTION_LINK } from 'constants/menPowerSupport'
import { PhytoVariantData } from 'redux/slices/checkout-men-power-slice'

export const MAIS_LIB_VARIANTS: PhytoVariantData[] = [
  {
    variantId: IS_PRODUCTION ? 1197 : 1167,
    label: '+lib',
    description:
      'Os médicos da Omens desenvolveram um suplemento natural dedicado à recuperação da libido e do prazer sexual. Baseado na ciência, o suplemento atua na baixa de libido, nos sintomas da andropausa e na disfunção erétil.',
    price: 295,
    imgSrc: '/patientArea/phyto/mais-lib.png',
    amount: 3,
    descriptionSrc: MEN_POWER_SUPPORT_DESCRIPTION_LINK
  }
  // {
  //   variantId: IS_PRODUCTION ? 1198 : 1168,
  //   label: '+lib',
  //   description:
  //     'Os médicos da Omens desenvolveram um suplemento natural dedicado à recuperação da libido e do prazer sexual. Baseado na ciência, o suplemento atua na baixa de libido, nos sintomas da andropausa e na disfunção erétil.',
  //   price: 472,
  //   imgSrc: '/patientArea/phyto/mais-lib.png',
  //   amount: 6,
  //   descriptionSrc: MEN_POWER_SUPPORT_DESCRIPTION_LINK
  // }
]

export const MAIS_FERT_VARIANTS: PhytoVariantData[] = [
  {
    variantId: IS_PRODUCTION ? 1184 : 1154,
    label: '+fert',
    description: '',
    price: 190,
    imgSrc: '/patientArea/phyto/mais-fert.png',
    amount: 1,
    descriptionSrc: ''
  },
  {
    variantId: IS_PRODUCTION ? 1185 : 1155,
    label: '+fert',
    description: '',
    price: 519,
    imgSrc: '/patientArea/phyto/mais-fert.png',
    amount: 3,
    descriptionSrc: ''
  }
]

export const MAIS_HAIR_VARIANTS: PhytoVariantData[] = [
  {
    variantId: IS_PRODUCTION ? 1181 : 1151,
    label: '+hair',
    description: '',
    price: 194,
    imgSrc: '/patientArea/phyto/mais-hair.png',
    amount: 3,
    descriptionSrc: ''
  },
  {
    variantId: IS_PRODUCTION ? 1182 : 1152,
    label: '+hair',
    description: '',
    price: 310,
    imgSrc: '/patientArea/phyto/mais-hair.png',
    amount: 6,
    descriptionSrc: ''
  }
]

export const GLP1_DAILY_SUPPORT_VARIANTS: PhytoVariantData[] = [
  {
    variantId: 2495,
    label: 'GLP-1 Daily Support',
    description: '',
    price: 159,
    imgSrc: '/landings/glp1-daily-support-20260909.webp',
    amount: 1,
    descriptionSrc: ''
  },
  {
    variantId: 2496,
    label: 'GLP-1 Daily Support',
    description: '',
    price: 299,
    imgSrc: '/landings/glp1-daily-support-20260909.webp',
    amount: 3,
    descriptionSrc: ''
  }
]
